<script>
    import ButtonCircular from '../ButtonCircular.svelte'
    import CircularIndicator from '../CircularIndicator.svelte'
    import * as Fx from '../../globals/Fx'
    import { createEventDispatcher } from "svelte";
    
    const dispatch = createEventDispatcher();
    
    export let LIQUIDADOS = null
    
    let w
    let h
    
    const _handleClickEvent = (OPCION) => {
        dispatch("click",{opcion : OPCION})
    }
    
</script>


<div class="option-container d-flex flex-column align-items-center justify-content-center text-center mx-1 position-relative" style="max-width: 300px;">
    <div style="width: 200px;height:200px;" bind:clientWidth={w} bind:clientHeight={h}>
        {#if LIQUIDADOS }
            <CircularIndicator porc={LIQUIDADOS.porc_recaudo} {w} {h} lineWidth={20} label="Recaudo">
                <div class="buttons">
                    <ButtonCircular
                        {w} {h} n={2} title={"Mostrar Listado"} on:click={() =>_handleClickEvent("RECAUDO-LISTADO")}
                    >
                        <ion-icon name="list-outline"></ion-icon>
                    </ButtonCircular>
                </div>
            </CircularIndicator>
        {:else}
            <CircularIndicator porc={0} {w} {h} lineWidth={20} label="Recaudo">
                <div class="buttons">
                    <ButtonCircular
                        {w} {h} n={2} title={"Mostrar Listado"} on:click={() =>_handleClickEvent("RECAUDO-LISTADO")}
                    >
                        <ion-icon name="list-outline"></ion-icon>
                    </ButtonCircular>
                </div>
            </CircularIndicator>
        {/if}
    </div>
    <span class="title-desc">Recaudo</span>
    <p style="color:#00000055">Hasta el momento se presenta recaudos por valor de <strong>{LIQUIDADOS ? Fx.formatter.format(LIQUIDADOS.total_recaudo).cop() : 0}</strong> de un total de importe liquidado de <strong>{LIQUIDADOS ? Fx.formatter.format(LIQUIDADOS.total_importe_liquidado).cop() : 0}</strong> </p>
</div>


<style>
    .title-desc {
        margin-top: 10px;
        color: #34495e;
        font-size: 1.5em;
        font-weight: bold;
    }

    .buttons {
        opacity: 0;
        transition: opacity 500ms;
    }

    .option-container:hover .buttons {
        display: flex;
        opacity: 1;
    }        

</style>